module.exports = __webpack_public_path__ + "static/media/burning_mask.ad246fd2.jpg";